import Vue from 'vue';
import {database} from '@/firebase.js';
export default {
    state:{
      sesiones:{
        web:[]
      }
    },
    mutations: {
      setSesiones(state,sesiones){
        state.sesiones.web=sesiones;
      },
    },
    actions: {
      Actualizar_Sesiones(context){
        //Base de datos de las sesiones
        var name_firebase_database = context.rootState.cia.cia.firebase_realtime;
        var sesiones = database.ref(name_firebase_database+'/sesiones/web');

        //Al escuchar un cambio en las sesiones, actualizo los datos
        sesiones.on('value', function(querySnapshot) {
          var datos = [];
          var tengo_sesion=false;
          querySnapshot.forEach(function(snapshot) {
            if (snapshot.key==context.rootState.menu.menu.usuario.firebase_id) {
              tengo_sesion=true;
            }
            datos.push(snapshot.val());
          });
          if (!tengo_sesion && !context.rootState.menu.menu.salir) {
            swal({
              title: "Sesión Caducada",
              text: "Otra persona está utilizando este usuario",
              icon: "error",
              button: "Aceptar"
            }).then((value) => {
              $('#Cerrar_Sesion_LMS').click();
            });
          }else{
            context.commit('setSesiones',datos);
          }
        });
      },
    },
    getters: {
      getSesiones(state){
        return state.sesiones.web;
      },
      getTotalSesiones(state){
        return state.sesiones.web.length;
      },
    },

}



// WEBPACK FOOTER //
// ./src/modules/sesiones.js